/**
 * Compare function that finds the larger of two strings by using descending
 * order for numbers and ascending order for letters. This places names with
 * a year prefix in descending order by year, ascending order by alpha name.
 * @param a
 * @param b
 * @returns 0 when a and b are equal, -1 when a is smaller than b, 1 when a is larger than b
 */
export function naturalListOrder(a:string, b:string) {
   // get the shorter one
   const length = Math.min(a.length, b.length);

   for (let i = 0; i < length; i++) {
     const elementA = a[i];
     const elementB = b[i];
     if (elementA != elementB) {
       const aIsAlpha = isNaN(Number(elementA));
       const bIsAlpha = isNaN(Number(elementB));
       if (aIsAlpha != bIsAlpha) {
         return aIsAlpha ? 1 : -1;
       }
       const bothAreAlpha = aIsAlpha && bIsAlpha;
       if (bothAreAlpha) {
         return elementA < elementB ? -1 : 1;
       } else {
         return elementB < elementA ? -1 : 1;
       }
     }
   }

   return 0;
}
